import { render, staticRenderFns } from "./itemOutManageList.vue?vue&type=template&id=c96bd132&scoped=true"
import script from "./itemOutManageList.vue?vue&type=script&lang=js"
export * from "./itemOutManageList.vue?vue&type=script&lang=js"
import style0 from "./itemOutManageList.vue?vue&type=style&index=0&id=c96bd132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96bd132",
  null
  
)

export default component.exports